<template>
  <v-container fluid>
    <h2 class="mt-5 mb-6">{{$t('schedule')}}</h2>
    <v-card>
      <v-tabs background-color="white" color="primary" left @change="changeActiveTab($event)">
        <v-tab>{{$t('manage_shift_code')}}</v-tab>
        <v-tab>{{$t('schedule_pattern')}}</v-tab>
        <v-tab>{{$t('schedule_shifting')}}</v-tab>

        
        <v-tab-item>
          <v-container fluid>
            <Time v-if="tabActive == 0"></Time>
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <v-container fluid>
            <Patterns v-if="tabActive == 1"></Patterns>
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <v-container fluid>
            <Work v-if="tabActive == 2"></Work>
          </v-container>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </v-container>
</template>

<script>
// import axios from "axios";
import Work from "./components/Work";
import Time from "./components/Time";
import Patterns from "./components/Pattern";
export default {
  name: "schedule",
  data() {
    return {
      tabActive: 0
    };
  },
  methods: {
    changeActiveTab(e) {
      this.tabActive = e
    }
  },
  created() {},
  components: {
    Work,
    Time,
    Patterns
  }
};
</script>
